/* eslint-disable camelcase */
import { ListItemText } from '@mui/material';
import React from 'react';
import RecordKeyDates from '../../../record-viewer/record-key-dates';
import { SystemRecordTypeEnum } from '../../../record-viewer/types';

interface Props {
  record: Record<string, any>,
}

const RecordPickerItem: React.FC<Props> = ({
  record,
}) => {
  const { title } = record;
  const { created_at } = record;
  const systemRecordType = SystemRecordTypeEnum.Records;
  return (
    <ListItemText
      disableTypography
      primary={title}
      secondary={(
        <RecordKeyDates
          createdAt={created_at}
          systemRecordType={systemRecordType}
        />
      )}
    />
  );
};

export default RecordPickerItem;
